import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			icon: {
				marginRight: 5,
				width: 32,
				height: 32
			},
			title: {
				fontSize: 12,
				color: theme.palette.grey[700]
			},
			value: {
				color: theme.palette.common.black,
				fontSize: 14,
				fontWeight: 500,
				marginTop: 3
			}
		}),
	{
		name: "InformationItem",
		index: 1
	}
);

export default useStyles;
